import React from 'react';

/**
 * Universal vector Dental Implant Icon (Fixture + Abutment)
 */
export const DentalImplantIcon = ({ size = 12, className = '' }) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="currentColor" 
        className={className}
        style={{ display: 'inline-block', verticalAlign: '-1.5px' }}
        aria-hidden="true"
    >
        {/* Hexagonal / Abutment head */}
        <polygon points="7,2 17,2 20,6 4,6" />
        {/* Implant collar ring */}
        <rect x="5" y="7.2" width="14" height="1.8" rx="0.5" />
        {/* Threaded titanium screw shaft */}
        <rect x="5.5" y="10" width="13" height="1.6" rx="0.4" />
        <rect x="6" y="12.4" width="12" height="1.6" rx="0.4" />
        <rect x="6.5" y="14.8" width="11" height="1.6" rx="0.4" />
        <rect x="7" y="17.2" width="10" height="1.6" rx="0.4" />
        {/* Tapered apex */}
        <polygon points="7.5,19.6 16.5,19.6 12,23" />
    </svg>
);

/**
 * Detects whether a case involves dental implantology / implants.
 * Checks category, item names, descriptions, notes, and product catalog.
 */
export const isCaseImplant = (order, productsList = []) => {
    if (!order) return false;

    // Explicit override if set on the order
    if (order.isImplant === true) return true;
    if (order.isImplant === false) return false;

    const checkStr = (val) => {
        if (!val) return false;
        const s = String(val).toLowerCase();
        return (
            s.includes('implant') ||
            s.includes('pilier') ||
            s.includes('scanbody') ||
            s.includes('scan-body') ||
            s.includes('scan body') ||
            s.includes('transviss') ||
            s.includes('transfix') ||
            s.includes('faux moignon implantaire') ||
            s.includes('pilier calcinable') ||
            s.includes('all-on-4') ||
            s.includes('all on 4') ||
            s.includes('all-on-6') ||
            s.includes('all on 6') ||
            s.includes('pilier multi-unit') ||
            s.includes('pilier multi unit') ||
            s.includes('mua') ||
            s.includes('tibase') ||
            s.includes('ti-base') ||
            s.includes('vis définitive') ||
            s.includes('vis definitive')
        );
    };

    // 1. Direct fields on the order
    if (checkStr(order.workType) || checkStr(order.notes) || checkStr(order.patientReference)) {
        return true;
    }

    // 2. TeethConfig items
    if (order.teethConfig) {
        if (Array.isArray(order.teethConfig)) {
            return order.teethConfig.some(line => {
                if (!line) return false;
                if (checkStr(line.category) || checkStr(line.name) || checkStr(line.notes)) {
                    return true;
                }
                if (line.productId && Array.isArray(productsList) && productsList.length > 0) {
                    const prod = productsList.find(p => p.id === line.productId);
                    if (prod && (checkStr(prod.category) || checkStr(prod.name))) {
                        return true;
                    }
                }
                return false;
            });
        } else if (typeof order.teethConfig === 'object') {
            return Object.values(order.teethConfig).some(config => {
                if (!config) return false;
                if (checkStr(config.category) || checkStr(config.name) || checkStr(config.notes)) {
                    return true;
                }
                if (config.productId && Array.isArray(productsList) && productsList.length > 0) {
                    const prod = productsList.find(p => p.id === config.productId);
                    if (prod && (checkStr(prod.category) || checkStr(prod.name))) {
                        return true;
                    }
                }
                return false;
            });
        }
    }

    return false;
};
